<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import Loader from "@/components/widgets/preloader";
import { mapGetters,mapActions,mapState } from "vuex"
import Swal from "sweetalert2";
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Shop Purchases",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    Loader,
  },
  data() {
    return {
      title: "Purchase Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Shop Purchases Report",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "details",
          sortable: true,
          label: "",
        },
        {
          key: "tt_amt",
          sortable: true,
          label: "TOTAL",
        },
        {
          key: "amt_paid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "discount_field",
          sortable: true,
          label: "DISCOUNT",
        },
        {
          key: "supplier",
          sortable: true,
          label: "SUPPLIER",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "user",
          sortable: true,
          label: "RECORDED BY",
        },
        {
          key: "actions",
          sortable: false,
          label: "ACTION",
        },
      ],
      fields1: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "details",
          sortable: true,
          label: "",
        },
        {
          key: "tt_amt",
          sortable: true,
          label: "TOTAL",
        },
        {
          key: "amt_paid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "discount_field",
          sortable: true,
          label: "DISCOUNT",
        },
        {
          key: "supplier",
          sortable: true,
          label: "SUPPLIER",
        },
        {
          key: "invoice",
          sortable: true,
          label: "INVOICE NO",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "user",
          sortable: true,
          label: "RECORDED BY",
        },
        {
          key: "actions",
          sortable: false,
          label: "ACTION",
        },
      ],
      returnData:{
        purchase_id:'',
        product_id:'',
        product_name:'',
        quantity:'',
        unit_price:'',
        batch:'',
        date:moment(new Date()).format("YYYY-MM-DD"),
        reason:'',
        mode:'',
        type:0,
        filterdata:{}
      },
      edit: {
          id: "",
          total: "",
          paid: "",
          mode: "",
      },
      deleteData: {
          id: "",
          filterdata: {}
      },
      editData: {
          id: "",
      },
      amountError: "",
      modeError: "",

      data: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        supplier: "",
        branch_id:0,
        invoiceno:''
      },

      totals:{
        totalAmount:0,
        totalPaid:0,
        totalDiscount:0,
        totalBalance:0,
      }, 

    };
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("purchase", ["SaveStatus","PurchasesReturn","PurchasesData"]),
    ...mapGetters("auth",["MyUserPerm","business","branch","Branches","branchid"]),
    ...mapGetters("setting", ["PaymentOptions","GeneralSettings"]),
    ...mapGetters("stock", ["Suppliers"]),
    ...mapGetters("products", ["Products"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.PurchasesData ? this.PurchasesData.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.PurchasesData ? this.PurchasesData.length : 1;
  },
  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
            this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    PurchasesData(newValue){
      if(newValue){
        this.PurchaseData();
      }
    }
  },
  methods: {
    ...mapActions({
      FetchPurchases: "purchase/fetchShopPurchasesData",
      EditPaid: "purchase/editAmtPaidMode",
      EditPurchase: "purchase/editPurchase",
      DeletePurchase: "purchase/deletePurchase",
      FetchModes: "setting/fetchPaymentOptions",
      FetchReturns: "purchase/fetchReturns",
      SaveReturn: "purchase/returnShopPurchase",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchSuppliers: "stock/fetchSuppliers",
      FetchProducts: "products/fetchProducts",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    resetModal() {
      this.edit.id = "";
      this.edit.total = "";
      this.edit.paid = "";
      this.edit.mode = "";
    },
    resetError(){
        this.amountError = "";
        this.modeError = "";
    },
    resetDelete(){
        this.deleteData.id = "";
    },
    resetEdit(){
        this.editData.id = "";
    },
    showEditModal(data) {
      this.editData.id = data.item.id;
    },
    showDeleteModal(data) {
      this.deleteData.id = data.item.id;
    },
    addCommas() {
        this.edit.paid = this.thousandSeperator(this.edit.paid);
    },
    ShowEdit(data) {
        this.edit.id = data.id;
        this.edit.mode = data.payments[0].mode;
        this.edit.total = data.totAmt;
        this.edit.paid = this.thousandSeperator(data.amtPaid);
    },
    editAmt(modalId){
        this.modal_id = modalId;
        if(this.edit.paid==""){
            this.amountError = "Amount Paid is required";
            return
        }
        else{
            this.amountError = "";
        }
        if(this.edit.mode==""){
            this.modeError = "Payment Method is required";
            return
        }
        else{
            this.modeError = "";
        }
        this.EditPaid(this.edit);
    },
    editPurchase(modalId){
        this.modal_id = modalId;
        this.EditPurchase(this.editData);
    },
    deletePurchase(modalId){
        this.deleteData.filterdata = this.data;
        this.modal_id = modalId;
        this.DeletePurchase(this.deleteData);
    },
    closeModal(modalId) {
      this.resetError();
      this.resetModal();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    Receipt_print(Id){
      window.open(
        `https://${window.location.host}/receipts/purchasesreceipt.php?id=${btoa(Id)}`
      );
    },
    Showreturn_modal(data){
      this.returnData.purchase_id=data.purchase.id;
      this.returnData.product_id=data.product_id;
      this.returnData.product_name=data.product;
      this.returnData.unit_price=data.SPrice;
      this.returnData.quantity=data.qty;
      this.returnData.batch=data.batch;      
    },
    resetSave() {
      // this.resetErrors();
      this.returnData.purchase_id='';
      this.returnData.product_id='';
      this.returnData.product_name='';
      this.returnData.quantity='';
      this.returnData.unit_price='';
      this.returnData.batch='';
      this.returnData.reason='';
      this.returnData.date=moment(new Date()).format("YYYY-MM-DD");
      this.modal_id = "";
    },
    Return_purchase(){
      this.returnData.filterdata = this.data;
      this.SaveReturn(this.returnData);
      this.closeModal('return-purchase-modal');
    },

    filterReport(){
      this.FetchPurchases(this.data);
    },
    
    PurchaseData(){
      if(this.PurchasesData){
      let total_amount = 0;
      let total_paid = 0;
      let total_discount = 0;
      this.PurchasesData.forEach((item)=>{
        total_amount = total_amount+parseInt(item.totAmt);
        total_paid = total_paid+parseInt(item.amtPaid);
        total_discount = total_discount+parseInt(item.discount);

        this.totals.totalBalance = this.totals.totalAmount-(this.totals.totalPaid+this.totals.totalDiscount);
      });
      this.totals.totalPaid = total_paid;
      this.totals.totalAmount = total_amount;
      this.totals.totalDiscount = total_discount;  
      this.totals.totalBalance = total_amount-(total_paid+total_discount)
      }
    },
  },
  created() {
    this.FetchPurchases(this.data);
    this.FetchModes();
    this.FetchGeneralSettings();
    this.FetchSuppliers();
    this.FetchProducts();
  },
};
</script>

<template>
  <Layout>
    <div class="row py-3 text-center">
      <h4 v-if="GeneralSettings.show_businessname == 1" class="text-primary">{{business}}</h4><h4 v-if="GeneralSettings.show_branchname == 1 && branch"> <em  v-if="GeneralSettings.show_branchname == 1 && GeneralSettings.show_businessname == 1">-</em> {{branch}}</h4>
    </div>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-3">
                <b-button variant="info" @click="Excel_export()"
                  ><i class="fa fa-download"></i>Export</b-button>
              </div>
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center" v-html="title"></h3>
              </div>
            </div>
            <div class="row" v-if="branchid == 0">
              <div class="col-md-8"></div>
              <div class="col-md-4 mb-3">
                <label>FILTER BY BRANCHES</label>
                
                <model-list-select
                  :list="Branches ? Branches : []"
                  v-model="data.branch_id"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Branch"
                  @input="filterReport()"
                >
                </model-list-select>
              </div>
            </div> 
            <div class="row">
              <div class="col-md-9"></div>
              <div class="col-md-3 form-group">
                <label>PRODUCT</label>               
                <model-list-select
                  :list="Products ? Products : []"
                  v-model="data.product"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Product"
                  @input="filterReport()"
                >
                </model-list-select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2">
                <div class="form-group">
                  <label>From</label>
                  <input
                    type="date"
                    v-model="data.datefrom"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>To</label>
                  <input
                    type="date"
                    v-model="data.dateto"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-3 form-group">
                <label>SUPPLIERS</label>
                
                <model-list-select
                  :list="Suppliers ? Suppliers : []"
                  v-model="data.supplier"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Supplier"
                  @input="filterReport()"
                >
                </model-list-select>
              </div>
              <div class="col-md-3 form-group">
                <label>INVOICE NO.</label>                
                <input
                  class="form-control"
                  v-model="data.invoiceno"
                  placeholder="Enter Invoice No"
                  @keyup.enter="filterReport()"
                />
              </div>
              <div class="col-md-2 mt-4">
                <button class="btn btn-primary" type="button" @click="filterReport()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="SaveStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="PurchasesData?PurchasesData:[]"
                  :fields="GeneralSettings.capture_purchase_invoiceno == 1?fields1:fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(tt_amt)="data">
                  {{ thousandSeperator(data.item.totAmt) }}
                </template>
                <template #cell(amt_paid)="data">
                  <span class="text-warning" 
                  v-b-modal.expired-modal
                    @click="ShowEdit(data.item)" v-if="data.item.numpaid==1">
                    {{ thousandSeperator(data.item.amtPaid) }}
                    </span>
                    <span v-else>
                    {{ thousandSeperator(data.item.amtPaid) }}
                    </span>
                </template>
                <template #cell(discount_field)="data">
                  {{ thousandSeperator(data.item.discount) }}
                </template>
                <template #cell(actions)="data">
                  <div>
                    <b-dropdown text="More Actions..." size="sm" class="btn-primary"  v-if="MyUserPerm.modify_purchases == 1">
                        <b-dropdown-item 
                          v-b-modal.delete-purchase-modal
                          v-if="MyUserPerm.delete_purchase == 1"
                          @click="showDeleteModal(data)">
                          <i class="fa fa-trash text-danger"></i> <span class="text-danger">Delete</span> 
                        </b-dropdown-item>
                        <b-dropdown-item
                          v-if="MyUserPerm.edit_purchase == 1"
                          v-b-modal.edit-purchase-modal
                          @click="showEditModal(data)"
                          ><i class="fa fa-edit text-primary"></i> <span class="text-primary">Edit</span>
                        </b-dropdown-item>
                        <b-dropdown-item variant="info" @click="Receipt_print(data.item.id)"><i class="fa fa-download"></i>Reprint</b-dropdown-item>
                    </b-dropdown>
                    </div>
                </template>
                <template #cell(details)="data">
                  <table  class="table">
                    <thead>
                      <th>PRODUCT</th>
                      <th>QTY</th>
                      <th>PRICE</th>
                    </thead>
                    <tbody>
                    <tr v-for="(det,d) in data.item.items" :key="d" width="100%">
                      <td>{{ det.product }}</td>
                      <td>{{ det.qty }}{{ det.usymbol }}</td>
                      <td>{{ det.unitPrice?thousandSeperator(det.unitPrice):0 }}</td>
                      <td>{{ det.batch }}</td>
                      <td>{{ det.expiry }}</td>
                      <td>
                        <b-button v-if="det.Returned == 1" variant="secondary" disabled>Returned</b-button>
                        <b-button v-else v-b-modal.return-purchase-modal @click="Showreturn_modal(det)" variant="primary">Return</b-button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </template>
              </b-table>

              <div class="row">
                  <div class="col-md-3">
                    <h5>Total Amount: <span class="text-danger">{{thousandSeperator(totals.totalAmount)}}</span></h5>
                  </div>
                  <div class="col-md-3">
                    <h5>Total Paid: <span class="text-danger">{{thousandSeperator(totals.totalPaid)}}</span></h5>
                  </div>
                  <div class="col-md-3">
                    <h5>Total Discount: <span class="text-danger">{{thousandSeperator(totals.totalDiscount)}}</span></h5>
                  </div>
                  <div class="col-md-3">
                    <h5>Total Balance: <span class="text-danger">{{thousandSeperator(totals.totalBalance)}}</span></h5>
                  </div>
              </div>
               <!-- modal starts -->
              <b-modal id="return-purchase-modal" hide-footer @hidden="resetSave">
              <template #modal-title> Return New Item </template>
              <div class="form-group mb-3">
                  <label>Product Name</label>
                  <div class="input-group">
                  <input
                      type="text"
                      placeholder="Enter product"
                      class="form-control" 
                      v-model="returnData.product_name"
                  />
                  </div>
              </div>
              <div class="form-group mb-3">
                  <label>Return Date</label>
                  <div class="input-group">
                  <input
                      type="date"
                      placeholder="Enter Date"
                      class="form-control"
                      v-model="returnData.date"
                  />
                  </div>
              </div>
              <div class="form-group mb-3">
                  <label>Quantity</label>
                  <div class="input-group">
                  <input
                      type="number"
                      placeholder="Enter quantity"
                      class="form-control" 
                      v-model="returnData.quantity"
                  />
                  </div>
              </div>
              <div class="form-group mb-3">
                  <label>Reason</label>
                  <div class="input-group">
                  <textarea
                      type="text"
                      placeholder="Enter reason"
                      class="form-control" 
                      v-model="returnData.reason"
                  ></textarea>
                  </div>
              </div>
              <div class="form-group mb-3">
                  <label>Payment Option</label>
                  <div class="input-group">
                  <model-list-select
                      :list="PaymentOptions ? PaymentOptions : []"
                      v-model="returnData.mode"
                      option-value="id"
                      option-text="mode"
                      placeholder="Select Mode"
                  >
                  </model-list-select>
                  </div>
              </div>
              <div class="modal-footer">
                  <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                  @click="closeModal('return-purchase-modal')"
                  >
                  <i class="fa fa-times"></i> Close
                  </button>
                  <button
                  type="button"
                  class="btn btn-primary"
                  @click="Return_purchase()"
                  > <i class="fa fa-check"></i>
                  Submit
                  <b-spinner
                      v-if="SaveStatus"
                      variant="light"
                      small
                      label="Spinning"
                  ></b-spinner>
                  </button>
              </div>
              </b-modal>
            <!-- modal ends --> 
            </div>
            <Loader  v-if="!PurchasesData"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
 <!-- modal mark as expired starts -->
    <b-modal id="expired-modal" hide-footer @hidden="resetModal()">
      <template #modal-title>
        <h4 class="text-warning">Edit Amount Paid For Purchase of {{ thousandSeperator(edit.total) }}</h4></template
      >
        <label>Amount Paid</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            v-model="edit.paid"
            placeholder="Quantity removed"
            @input="resetError(),addCommas()"
          />
        </div>
        <div class="text-danger" v-if="amountError">
          <em>{{ amountError }}</em>
        </div>
        <div class="form-group">
            <label>Payment Method <span class="text-danger">*</span></label>
            <model-list-select
                :list="PaymentOptions ? PaymentOptions : []"
                v-model="edit.mode"
                option-value="id"
                option-text="mode"
                placeholder="Select Method"
                @input="resetError()"
            >
            </model-list-select>
        </div>
        <div class="text-danger" v-if="modeError">
            <em>{{ modeError }}</em>
        </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('expired-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button type="button" class="btn btn-warning" @click="editAmt('expired-modal')">
          <i class="fa fa-minus"></i> Confirm
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Submiting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <b-modal
              header-bg-variant="warning"
              header-text-variant="light"
              body-text-variant="warning"
              footer-bg-variant="warning"
              footer-text-variant="warning"
              id="edit-purchase-modal"
              hide-footer
              @hidden="resetEdit"
            >
              <template #modal-title> Edit Purchase</template>
              <div class="form-group mb-2">
                <div class="input-group">
                  <h5>
                    Do you want to return and edit this Purchase? Click Proceed Button to Return Purchase for Editing.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('edit-purchase-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="editPurchase('edit-purchase-modal')"
                >
                  <i class="fa fa-edit"></i> Proceed
                  <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Deleting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->
            <b-modal
              header-bg-variant="danger"
              header-text-variant="light"
              body-text-variant="danger"
              footer-bg-variant="danger"
              footer-text-variant="danger"
              id="delete-purchase-modal"
              hide-footer
              @hidden="resetDelete"
            >
              <template #modal-title> Delete Purchase</template>
              <div class="form-group mb-2">
                <div class="input-group">
                  <h5>
                    Do you want to delete this Purchase? Click Proceed Button to delete.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('delete-purchase-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="deletePurchase('delete-purchase-modal')"
                >
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Deleting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
